var ThumbnailSizes;
(function (ThumbnailSizes) {
  ThumbnailSizes["ICON"] = "icon";
  ThumbnailSizes["THUMB"] = "thumb";
  ThumbnailSizes["PREVIEW"] = "preview";
  ThumbnailSizes["MEDIUM"] = "medium";
})(ThumbnailSizes || (ThumbnailSizes = {}));
export default ThumbnailSizes;